<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="transparent" flat elevation="0">
							<v-toolbar-title class="ml-0"
								>Subscription Plans
								<bc-breadcrumbs :items="breadcrumb_items"></bc-breadcrumbs>
							</v-toolbar-title>
							<v-spacer></v-spacer>
							<bc-btn-add
								v-if="hasPerm('subscriptions.create')"
								@invoke-method="invokeMethod($event)"
								action="openSubscriptionPlanForm"
							></bc-btn-add>
							<bc-btn-refresh @invoke-method="dbGetSubscriptionPlans(true)"></bc-btn-refresh>
							<bc-search-menu :params="axiosParams">
								<v-list>
									<v-list-tile>
										<bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
									</v-list-tile>
								</v-list>
							</bc-search-menu>
							<bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
						</v-toolbar>
					</v-layout>
				</v-container>

				<v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
					<v-data-table :headers="headers" :items="subscription_plans" :no-data-text="$t('lang.no_results_matching')" hide-actions>
						<template slot="items" slot-scope="props">
							<tr class="clickable" @mouseup.left="openSubscriptionPlanForm(props.item)">
								<td>{{ props.item.plan_code }}</td>
								<td>{{ props.item.plan_name }}</td>
								<td>{{ props.item.amount }} USD</td>
								<td class="text-center">{{ props.item.term_months }}</td>
								<td>
									<v-layout justify-center>
										<v-icon :color="props.item.is_active == '1' ? 'success' : 'error'" large>hgi hgi-solid hgi-checkmark-circle-02</v-icon>
									</v-layout>
								</td>
							</tr>
						</template>
					</v-data-table>
					<bc-pagination :page="page" :params="axiosParams" name="subscription_plans"></bc-pagination>
				</v-card-text>
			</v-card>

			<bc-dialog :value="subscription_plan_dialog">
				<v-card>
					<v-form ref="form_subscription_plan">
						<v-card-title>
							<span class="headline">{{ subscription_plan.plan_id ? $t("lang.edit_subscription_plan") : $t("lang.add_subscription_plan") }}</span>
							<v-spacer></v-spacer>
							<bc-btn-dialog-close
								@invoke-method="invokeMethod($event)"
								action="closeSubscriptionPlanDialog"
								:dialog-status="subscription_plan_dialog"
							></bc-btn-dialog-close>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-form>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-model="subscription_plan.plan_code"
											:label="`${$t('lang.plan_code')} *`"
											:counter="showCounter(subscription_plan.plan_code, 'subscription_plan.plan_code')"
											:rules="ifValid('subscription_plans.plan_code', { plan_id: subscription_plan.plan_id })"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="subscription_plan.plan_name"
											:label="`${$t('lang.plan_name')} *`"
											:counter="showCounter(subscription_plan.plan_name, 'subscription_plan.plan_name')"
											:rules="ifValid('subscription_plans.plan_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-textarea
											v-model="subscription_plan.description"
											:label="$t('lang.description')"
											auto-grow
											rows="1"
											:rules="ifValid('subscription_plans.description')"
										></v-textarea>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="subscription_plan.amount"
											:label="`${$t('lang.amount')} *`"
											:counter="showCounter(subscription_plan.amount, 'subscription_plan.amount')"
											:rules="ifValid('subscription_plans.amount')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="subscription_plan.currency_code"
											:label="`${$t('lang.currency_code')} *`"
											:counter="showCounter(subscription_plan.currency_code, 'subscription_plan.currency_code')"
											:rules="ifValid('subscription_plans.currency_code')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="subscription_plan.term_months"
											:label="`${$t('lang.term_months')} *`"
											:rules="ifValid('subscription_plans.term_months')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-select
											v-model="subscription_plan.is_active"
											:label="`${$t('lang.is_active')} *`"
											:items="[
												{ text: $t('lang.yes'), value: '1' },
												{ text: $t('lang.no'), value: '0' },
											]"
											item-value="value"
											item-text="text"
											:rules="ifValid('subscription_plans.is_active')"
										></bc-select>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="subscription_plan.zoho_item_id"
											:label="$t('lang.zoho_item_id')"
											:counter="showCounter(subscription_plan.zoho_item_id, 'subscription_plan.zoho_item_id')"
											:rules="ifValid('subscription_plans.zoho_item_id')"
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-btn v-if="subscription_plan.plan_id" color="error" @mouseup.left="$refs.delete_subscription_plans.openDialog()">{{
								$t("lang.delete")
							}}</v-btn>
							<v-spacer></v-spacer>
							<v-btn flat @mouseup.left="closeSubscriptionPlanDialog()">{{ $t("lang.cancel") }}</v-btn>
							<v-btn color="success" @click="saveSubscriptionPlans">{{ $t("lang.save") }}</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</bc-dialog>
			<delete-confirmation-dialog
				ref="delete_subscription_plans"
				:heading="$t('lang.delete_subscription_plan')"
				:message="$t('lang.confirm_delete_message')"
				@onConfirm="deleteSubscriptionPlans(subscription_plan.plan_id)"
			></delete-confirmation-dialog>
		</v-container>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
	data() {
		return {
			mobile_list: [
				{ title: this.$t("lang.add_new"), action: "openSubscriptionPlanForm" },
				{ title: this.$t("lang.refresh"), action: "dbGetSubscriptionPlans", params: [true] },
			],
			headers: [
				{ text: this.$t("lang.plan_code"), sortable: false, width: "8%" },
				{ text: this.$t("lang.plan_name"), sortable: false, width: "8%" },
				{ text: this.$t("lang.amount"), sortable: false, width: "2%" },
				{ text: this.$t("lang.term_months"), sortable: false, width: "8%", align: "center" },
				{ text: this.$t("lang.is_active"), sortable: false, width: "8%", align: "center" },
			],
			enableAddModal: true,
			enableEditModal: true,

			subscription_plan: {},
			filter: {
				search: "",
			},
			subscription_plan_dialog: false,
			dbGetSubscriptionPlans: _.debounce(this.getSubscriptionPlans, 1500, { maxWait: 1500, leading: true, trailing: false }),
			breadcrumb_items: [
				{
					text: "Dashboard",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "dashboard",
					},
				},
				{
					text: "Configuration",
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: "configuration",
					},
				},
				{
					text: "Subscription Plans",
					disabled: true,
					href: "",
				},
			],
		};
	},
	beforeRouteEnter(to, from, next) {
		let parsedQuery = JSON.parse(JSON.stringify(to.query));
		store
			.dispatch("fetchSubscriptionPlans", {
				body: parsedQuery,
			})
			.then((data) => {
				if (typeof data !== "undefined" && data.subscription_plans) {
					next((vm) => {
						vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
						vm.finishLoader();
					});
				} else {
					next({ name: "dashboard", replace: true });
				}
			});
	},
	beforeRouteUpdate(to, from, next) {
		let parsedQuery = JSON.parse(JSON.stringify(to.query));
		this.fetchSubscriptionPlans({
			body: parsedQuery,
		}).then((data) => {
			if (typeof data !== "undefined" && data.subscription_plans) {
				this.setQuery(parsedQuery, this.filter, this.default_filter);
				this.finishLoader();
				next();
			} else {
				next({ name: "dashboard", replace: true });
			}
		});
	},
	computed: {
		...mapState({
			default_filter: (state) => state.subscription_plans.subscription_plans_filter,
			page: (state) => state.subscription_plans.page,
			rules_subscription_plans: (state) => state.subscription_plans.rules_subscription_plans,
			subscription_plan_status_options: (state) => state.settings.subscription_plan_status_options,
			subscription_plans: (state) => state.subscription_plans.subscription_plans,
		}),
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},
	},
	methods: {
		...mapActions(["fetchSubscriptionPlans", "saveSubscriptionPlan", "deleteSubscriptionPlan"]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
		openSubscriptionPlanForm(item = null) {
			if (item != null) {
				if (this.enableEditModal) {
					if (this.customers == null) this.getCustomers();
					if (this.$refs.form_subscription_plan)
						item ? this.$refs.form_subscription_plan.resetValidation() : this.$refs.form_subscription_plan.reset();

					this.$nextTick(() => {
						this.subscription_plan = item != null ? this.assignObj2(item, this.rules_subscription_plans) : {};
						this.subscription_plan_dialog = true;
					});
				} else {
					this.$router.push({ name: "subscription_plan", params: { id: item.plan_id } });
				}
			} else {
				this.subscription_plan = {};
				if (this.enableAddModal) {
					if (this.customers == null) this.getCustomers();
					if (this.$refs.form_subscription_plan)
						item ? this.$refs.form_subscription_plan.resetValidation() : this.$refs.form_subscription_plan.reset();
					this.subscription_plan_dialog = true;
				} else {
					this.$router.push({ name: "subscription_plan" });
				}
			}
		},
		saveSubscriptionPlans() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("form_subscription_plan")) {
					let body = this.prepForm(this.subscription_plan, this.rules_subscription_plans);

					this.saveSubscriptionPlan({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							if (this.enableEditModal) {
								this.getSubscriptionPlans();
								this.closeSubscriptionPlanDialog();
							} else {
								this.$router.push({ name: "subscription_plan", params: { id: data.plan_id } });
							}
						} else {
							//this.toggleModalLoader(false);
						}
					});
				}
			});
		},
		deleteSubscriptionPlans(id = null) {
			this.deleteSubscriptionPlan({
				id: id,
			}).then((data) => {
				if (data && data.code == "200") {
					this.getSubscriptionPlans();
					this.closeSubscriptionPlanDialog();
				} else {
					this.toggleModalLoader(false);
				}
			});
		},

		closeSubscriptionPlanDialog() {
			this.subscription_plan_dialog = false;
			this.$refs.delete_subscription_plans.close();
			this.validationOff();
			this.toggleModalLoader(false);
		},
		getSubscriptionPlans(pg_refresh = false) {
			this.startLoader();

			this.fetchSubscriptionPlans({
				body: JSON.parse(JSON.stringify(this.$route.query)),
			})
				.then((data) => {
					if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
				})
				.finally(() => {
					this.subscription_plan_dialog = false;
					this.toggleModalLoader(false);
					this.validationOff();
					this.finishLoader(pg_refresh);
				});
		},
		getCustomers() {
			this.$store
				.dispatch("fetchCustomers", {
					url: "me/companies?module=people",
					method: "get",
				})
				.then((data) => {
					if (typeof data !== "undefined") {
						this.customers = data.companies;
					}
				});
		},
	},
};
</script>
